import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container, } from "react-bootstrap";
import { connect } from "react-redux";
import { addCoupons } from "./Coupons.action";
import { setHeading } from "../../../accounts/account.actions";
import { GlobalSpinner, showSuccessAlert, showErrorAlert } from "../../../../../global/globalFunctions";
import _ from "lodash";
import Select from "react-select";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import moment from "moment";


const AddCoupons = (props) => {
  const [couponName, setCouponName] = useState("");
  const [couponsCode, setCouponsCode] = useState();
  const [couponsAmount, setCouponsAmount] = useState(0);
  const [couponTypeName, setCouponTypeName] = useState();

  function uploadCoupons() {
    props.addCoupons({
      code: couponsCode,
      name: couponName,
      type: couponTypeName,
      amount: couponsAmount,
      expiredAt: moment().add(1, 'M').format('YYYY-MM-DD'),
    },
      showSuccessAlert,
      showErrorAlert
    );
    setCouponName("")
    setCouponsCode("")
    setCouponsAmount("")
    setCouponTypeName("")
  }

  let CouponTypeData = [{
    CouponType_id: 1,
    CouponType_name: "fixed",
  },
  {
    CouponType_id: 2,
    CouponType_name: "percentage",
  }];
  const handleChangeCouponType = (selectedOption) => {
    setCouponTypeName(selectedOption.label);
  };
  const CouponTypeList = !_.isEmpty(CouponTypeData) && CouponTypeData.map((x) => {
    let data = { value: x.CouponType_id, label: x.CouponType_name };
    return data;
  });

  useEffect(() => {
    props.setHeading("Add Coupon");
  }, []);

  return (
    <>
      {props.isAddingCoupons ? (
        <GlobalSpinner />
      ) : (
        <Container fluid>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Coupon Name *</b></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Coupons Name"
                  onChange={(e) => { setCouponName(e.target.value); }}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Coupon Code *</b></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Coupon Code"
                  onChange={(e) => { setCouponsCode(e.target.value); }}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Coupon Type *</b></Form.Label>
                <Select
                  isDisabled={_.isEmpty(CouponTypeData)}
                  placeholder="Coupon Type"
                  onChange={handleChangeCouponType}
                  options={CouponTypeList}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Coupon Amount *</b></Form.Label>
                <Form.Control
                  type="number"
                  max={couponTypeName == "percentage" ? 100 : 99999999999999}
                  value={couponsAmount}
                  placeholder="Coupon Amount"
                  onChange={(e) => { setCouponsAmount(e.target.value); }}
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="sendDiv">
            {_.isEmpty(couponName) || _.isEmpty(couponTypeName) || _.isEmpty(couponsCode) || _.isEmpty(couponsAmount) ? (
              <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
            ) : (
              <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={uploadCoupons}> SAVE </Button>
            )}
          </div>

        </Container>
      )}
    </>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    addCoupons: (data, showSuccessAlert, showErrorAlert) => dispatch(addCoupons(data, showSuccessAlert, showErrorAlert)),
    setHeading: (data) => dispatch(setHeading(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  couponsList: state.CouponReducer.couponsList,
  isAddingCoupons: state.CouponReducer.isAddingCoupons,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddCoupons);